import { render, staticRenderFns } from "./ExamBubble.vue?vue&type=template&id=147912c4&"
import script from "./ExamBubble.vue?vue&type=script&lang=js&"
export * from "./ExamBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports